export default {
  getParameterByName: function(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  /**
   * Checks if the given string starts with https.
   * @param {string} string
   * @returns {boolean}
   */
  isValidUrl: function(string) {
    return string.toLowerCase().startsWith('https://');
  },
  isWhiteListedDomain(url, allowedDomains) {
    try {
      const {hostname} = new URL(url);

      return allowedDomains.some((domain) => {
        if (domain.startsWith('*')) {
          // Handle wildcard subdomains (*.example.com)
          const baseDomain = domain.slice(2); // Remove '*.'
          return hostname.endsWith(`.${baseDomain}`);
        }
        return hostname === domain; // Exact match
      });
    } catch (e) {
      return false; // Invalid URL
    }
  },
  isValidDomain(domain) {
    const domainPattern = /^(?:\*\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return domainPattern.test(domain);
  },
};
